export default {
  AddonAdda: 'ஒரு அடா',
  notFindAdda:
    'உங்கள் అడ్డా ஐ கண்டுபிடிக்க முடியவில்லை? உங்கள் Adda ஐச் சேர்க்கவும்',
  AddPhoto: 'படத்தில்',
  earnMpoints:
    'MPoints சம்பாதிக்க ஒரு Adda இல் ஒரு Adda அல்லது Checkin ஐச் சேர்க்கவும்',
  postOffice: 'தபால் அலுவலகம்',
  meter: 'மீட்டர்',
  VerifiedbyMall91: 'Mall91 ஆல் சரிபார்க்கப்பட்டது',
  Suggestandedit: 'திருத்தத்தை பரிந்துரைக்கவும்',
  GiveRating: 'மதிப்பீடு கொடுங்கள்',
  Details: 'விவரங்கள்',
  MondaytoSaturday: 'திங்கள் முதல் சனி வரை',
  checkIn: 'புதுப்பிப்பது',
  CheckInAtAdda: 'ஒரு அடாவில் சரிபார்க்கவும்',
  ShareExperience:
    'உங்கள் அனுபவத்தை அடிடாவுடன் பகிர்ந்து கொள்ளுங்கள் மற்றும் எம்.பி.',
  AddaName: 'அடாவின் பெயர்',
  AddAddanotfound: 'அடிடா கிடைக்கவில்லை',
  Iamhere: 'நான் இங்கு இருக்கிறேன்',
  Writesomethinghere: 'சில சொற்களை எழுதுங்கள் ..',
  plzCheckin: 'புதுப்பிப்பது',
  PickyourCurrentLocation: 'உங்கள் தற்போதைய இருப்பிடத்தைத் தேர்வுசெய்க',
  TurnonLocation: 'இருப்பிட சேவைகளை இயக்கவும்',
  NoRecordsavailable: 'பதிவுகள் எதுவும் கிடைக்கவில்லை',
  YoursPosts: 'உங்கள் இடுகைகள்',
  Makeasuggestion: 'ஒரு பரிந்துரை செய்யுங்கள்',
  Helpwithyoursuggestion:
    'உங்கள் மதிப்புமிக்க பரிந்துரைகளுக்கு எங்களுக்கு உதவுங்கள்',
  Addnewphoto: 'புதிய புகைப்படத்தைச் சேர்க்கவும்',
  warning:
    'தொடர்புடைய படங்கள் மற்றும் துல்லியமான தகவல்களுடன் உங்கள் பரிந்துரைகளை ஆதரிக்கவும்.',
  submit: 'சமர்ப்பி',
  AllcheckIns: 'எல்லா செக்',
  Nearbycheckins: 'அருகாமை செக்',
  Home: 'வீடு',
  AllAddas: 'ஆல் ஆடா',
  Notification: 'அறிவித்தல்',
  Profile: 'சுயவிவர',
  TotalPost: 'அஞ்சல்',
  TotalLikes: 'தோட்',
  TotalComments: 'கருத்துகள்',
  Peoplehavecommented: 'மக்கள் கருத்து தெரிவித்துள்ளனர்',
  TypeAcomment: 'உங்கள் உள்ளடக்கத்தை இங்கே தட்டச்சு செய்க ..',
  GototheAdda: 'ஒரு அடிடாவுக்குச் செல்லுங்கள்',
  intro:
    'ஒரு అడ్డా இல் புதிய అడ్డా அல்லது చెకిన్ ஐச் சேர்த்து MPoints ஐப் பெறுங்கள்',
  Peoplehaveliked: 'மக்கள் விரும்பினர்',
  whichplaceyoustand:
    'நீங்கள் இப்போது எந்த அடாவில் இருக்கிறீர்கள்? புதுப்பிப்பது!',
  Atwhichplace: 'நீங்கள் இப்போது எந்த அடாவில் இருக்கிறீர்கள்? புதுப்பிப்பது!',
  likes: 'தோட்',
  share: 'பகிர்',
  like: 'போல்',
  comments: 'கருத்துக்கள்',
  isAt: 'இல் உள்ளது',
  FullAddress: 'முழு முகவரி',
  housenumber: 'வீட்டு எண், தெரு அல்லது கிராமம்',
  BusinessName: 'வணிகத்தின் பெயர்',
  Suchas: 'அகர்வால் மிட்டாய்',
  AddNewCategory: 'புதிய வகையைச் சேர்க்கவும்',
  CREATE: 'உருவாக்க',
  CANCEL: 'இரத்து',
  city: 'நகரம்',
  addCity: 'நகரத்தைச் சேர்',
  Mobile: 'தொடர்பு எண்',
  enterMobileNumber: 'மொபைல் எண்ணை உள்ளிடவும்',
  pincode: 'பின்னை',
  enterpincode: 'பின்னை',
  state: 'நிலை',
  AddState: 'மாநிலத்தைச் சேர்',
  wentWrong: 'ஏதோ தவறு ஏற்பட்டது !! மீண்டும் முயற்சிக்கவும்',
  category: 'வகை',
  Createcategory: 'வகை உருவாக்கவும்',
  UploadingImage: 'புகைப்பட பதிவேற்றம்',
  AddAdda: 'அடிடாவைச் சேர்க்கவும்',
  nofeed: 'செய்தி இல்லை',
  PleaseEnterdetails: 'விவரங்களை உள்ளிடவும்',
  Pleaseentercomment: 'கருத்தை உள்ளிடவும்',
  NoRecordsfound: 'இல்லை ரெக்கார்ட்ஸ் காணப்படும்',
  Citymustbevalid: 'நகரம் செல்லுபடியாகும்',
  Pinmustbevalid: 'முள் செல்லுபடியாகும்',
  Mobilenomustbevalid: 'அலைபேசி எண். செல்லுபடியாகும்',
  Businessnamemustbevalid: 'வணிக பெயர் செல்லுபடியாகும்',
  Photo: 'புகைப்பட',
  Pleaseselectshopname: 'கடை பெயரைத் தேர்ந்தெடுக்கவும்',
  Pleaseuploadphoto: 'புகைப்படத்தை பதிவேற்றவும்',
  isnecessary: 'அவசியம்!',
  Categorycreated: 'வகை வெற்றிகரமாக உருவாக்கப்பட்டது',
  ThisCategoryAlreadyExists: 'இந்த வகை ஏற்கனவே உள்ளது',
  Pleasecreatecategory: 'வகையை உருவாக்கவும்'
}
